import generateTimeLimits from 'utils/custom/generateTimeLimits';

const limits = generateTimeLimits({
  interval: 5,
  limit: 90,
});

export default limits;
